module.exports = __webpack_public_path__ + "static/accounts_ibm_cloud_2-82aad054482891a5ea6b875a1814e665.png";